import { Close } from "@material-ui/icons";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  Box,
  Checkbox,
  Dialog,
  FormControlLabel,
  Grid,
  IconButton,
  Paper,
  Radio,
  Tab,
  Tabs,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import SelectDentiraProductFilters from "../../../../Commons/SelectField/filters";
import {
  DialogBox,
  Drawer,
  DrawerHeader,
  TablePagination,
} from "../../../../Styles";
import MappingCard from "./MappingCard";
import {
  HeaderTypography,
  MappingContainer,
  MappingPaper,
  TitleTypography,
  SubtitleTypography,
  HeaderLabelTypography,
  CategoryTypography,
  ProductNameTypography,
  StyledTabs,
  TabLabelBox,
  TabLabelText,
  TabCountText,
  SearchField,
  ProductListBox,
  ProductItemBox,
  ProductInfoBox,
  ProductPriceTypography,
  AddOnsContainer,
  AddOnItemGrid,
  AddOnNameContainer,
  StyledTab,
} from "./MappingFormStyles";
import {
  fetchAutocompleteDentiraPrimaryProducts,
  fetchAutocompleteDentiraAddOnsProducts,
  fetchDentiraProductFilters,
  addDentiraMapping,
  updateDentiraMapping,
  removeDentiraMapping,
} from "../../../../../actions/inventoryActionsV2";
import { updateSuccessMessage } from "../../../../../actions/commonActions";
import { MappingRuleNote } from "./MappingCardStyles";
import { ImgContainers, NoOption } from "../../../../Orders/OrdersStyles";
import { NoOptionsTypography } from "../../../../Commons/AutocompleteField/AutocompleteFieldStyles";
import { useDebounce } from "../../../../../commons/utils/useDebounce";

const size = 10;
const pageNo = 1;

const dialogBoxInitAction = {
  open: false,
  title: "",
  content: "",
  onTrue: () => {},
  onFalse: () => {},
};

const MappingFormV2 = ({
  open,
  item = null,
  mappingsPropData = [],
  onSubmit = null,
  onClose = null,
  ...props
}) => {
  const [oldMappings, setOldMappings] = useState([]);
  const [mappings, setMappings] = useState([]);

  const [selectedMappingId, setSelectedMappingId] = useState("");

  const [procedure, setProcedure] = useState("");
  const [subProcedure, setSubProcedure] = useState("");
  const [material, setMaterial] = useState("");

  const [procedureOptions, setProcedureOptions] = useState([]);
  const [subProcedureOptions, setSubProcedureOptions] = useState([]);
  const [materialOptions, setMaterialOptions] = useState([]);

  const [primaryProducts, setPrimaryProducts] = useState({});
  const [addOnsProducts, setAddOnsProducts] = useState({});

  const [primaryProductsPage, setPrimaryProductsPage] = useState(pageNo);
  const [addOnsProductsPage, setAddOnsProductsPage] = useState(pageNo);

  const [primaryProductsSize, setPrimaryProductsSize] = useState(size);
  const [addOnsProductsSize, setAddOnsProductsSize] = useState(size);

  const [selectedTab, setSelectedTab] = useState(0);
  const [primaryProductsSearchTxt, setPrimaryProductsSearchTxt] = useState("");
  const [addOnProductsSearchTxt, setAddOnProductsSearchTxt] = useState("");

  const [dialogBoxAction, setDialogBoxAction] = useState(dialogBoxInitAction);

  const fetchDentiraPrimaryProducts = async (params, body) => {
    const { fetchAutocompleteDentiraPrimaryProducts } = props;
    const result = await fetchAutocompleteDentiraPrimaryProducts(params, body);

    setPrimaryProducts(result);
  };

  const fetchDentiraAddOnsProducts = async (params, body) => {
    const { fetchAutocompleteDentiraAddOnsProducts } = props;
    const result = await fetchAutocompleteDentiraAddOnsProducts(params, body);

    setAddOnsProducts(result);
  };

  const debouncedFetchPrimaryProducts = useDebounce((params, body) => {
    fetchDentiraPrimaryProducts(params, body);
  }, 500);

  const debouncedFetchAddOnsProducts = useDebounce((params, body) => {
    fetchDentiraAddOnsProducts(params, body);
  }, 500);

  useEffect(() => {
    if (open) {
      fetchInitialFilters();
    }
  }, [open]);

  useEffect(() => {
    const body = {};
    if (procedure) body.procedure_type = procedure;
    if (selectedTab === 0 && subProcedure) body.sub_procedure = subProcedure;
    if (selectedTab === 0 && material) body.material = material;

    if (selectedTab === 0) {
      setPrimaryProductsPage(pageNo);
      setPrimaryProductsSize(size);

      debouncedFetchPrimaryProducts(
        {
          page: primaryProductsPage,
          size: primaryProductsSize,
          searchTxt: primaryProductsSearchTxt,
        },
        body
      );
    } else {
      setAddOnsProductsPage(pageNo);
      setAddOnsProductsSize(size);

      debouncedFetchAddOnsProducts(
        {
          page: addOnsProductsPage,
          size: addOnsProductsSize,
          searchTxt: addOnProductsSearchTxt,
        },
        body
      );
    }
  }, [selectedTab, primaryProductsSearchTxt, addOnProductsSearchTxt]);

  useEffect(() => {
    if (procedure && subProcedure && material) {
      fetchProcedureFilters({ procedure });
      setPrimaryProductsPage(pageNo);
      setAddOnsProductsPage(pageNo);
      setPrimaryProductsSize(size);
      setAddOnsProductsSize(size);
      fetchDentiraPrimaryProducts(
        {
          page: primaryProductsPage,
          size: primaryProductsSize,
          searchTxt: primaryProductsSearchTxt,
        },
        {
          procedure_type: procedure,
        }
      );

      fetchDentiraAddOnsProducts(
        {
          page: addOnsProductsPage,
          size: addOnsProductsSize,
          searchTxt: addOnProductsSearchTxt,
        },
        {
          procedure_type: procedure,
        }
      );

      setSubProcedure("");
      setSubProcedureOptions([]);
      setMaterial("");
      setMaterialOptions([]);
      return;
    }

    if (procedure && subProcedure) {
      fetchProcedureFilters({ procedure });
      setPrimaryProductsPage(pageNo);
      setAddOnsProductsPage(pageNo);
      setPrimaryProductsSize(size);
      setAddOnsProductsSize(size);
      fetchDentiraPrimaryProducts(
        {
          page: primaryProductsPage,
          size: primaryProductsSize,
          searchTxt: primaryProductsSearchTxt,
        },
        {
          procedure_type: procedure,
        }
      );
      fetchDentiraAddOnsProducts(
        {
          page: addOnsProductsPage,
          size: addOnsProductsSize,
          searchTxt: addOnProductsSearchTxt,
        },
        {
          procedure_type: procedure,
        }
      );
      setSubProcedure("");
      setSubProcedureOptions([]);
      setMaterial("");
      setMaterialOptions([]);
      return;
    }

    if (procedure) {
      fetchProcedureFilters({ procedure });
      setPrimaryProductsPage(pageNo);
      setAddOnsProductsPage(pageNo);
      setPrimaryProductsSize(size);
      setAddOnsProductsSize(size);
      fetchDentiraPrimaryProducts(
        {
          page: primaryProductsPage,
          size: primaryProductsSize,
          searchTxt: primaryProductsSearchTxt,
        },
        {
          procedure_type: procedure,
        }
      );
      fetchDentiraAddOnsProducts(
        {
          page: addOnsProductsPage,
          size: addOnsProductsSize,
          searchTxt: addOnProductsSearchTxt,
        },
        {
          procedure_type: procedure,
        }
      );
    }
  }, [procedure]);

  useEffect(() => {
    if (procedure && subProcedure && material) {
      fetchSubProcedureFilters({ procedure, subProcedure });
      setPrimaryProductsPage(pageNo);
      fetchDentiraPrimaryProducts(
        {
          page: primaryProductsPage,
          size: primaryProductsSize,
          searchTxt: primaryProductsSearchTxt,
        },
        {
          procedure_type: procedure,
          sub_procedure: subProcedure,
        }
      );

      setMaterial("");
      setMaterialOptions([]);
      return;
    }

    if (procedure && subProcedure) {
      fetchSubProcedureFilters({ procedure, subProcedure });
      setPrimaryProductsPage(pageNo);
      fetchDentiraPrimaryProducts(
        {
          page: primaryProductsPage,
          size: primaryProductsSize,
          searchTxt: primaryProductsSearchTxt,
        },
        {
          procedure_type: procedure,
          sub_procedure: subProcedure,
        }
      );
    }
  }, [subProcedure]);

  useEffect(() => {
    if (procedure && subProcedure && material) {
      // fetchMaterialFilters();
      setPrimaryProductsPage(pageNo);
      fetchDentiraPrimaryProducts(
        {
          page: primaryProductsPage,
          size: primaryProductsSize,
          searchTxt: primaryProductsSearchTxt,
        },
        {
          procedure_type: procedure,
          sub_procedure: subProcedure,
          material,
        }
      );
    }
  }, [material]);

  useEffect(() => {
    const body = {};
    if (procedure) body.procedure_type = procedure;
    if (subProcedure) body.sub_procedure = subProcedure;
    if (material) body.material = material;

    fetchDentiraPrimaryProducts(
      {
        page: primaryProductsPage,
        size: primaryProductsSize,
        searchTxt: primaryProductsSearchTxt,
      },
      body
    );
  }, [primaryProductsPage, primaryProductsSize]);

  useEffect(() => {
    const body = {};
    if (procedure) body.procedure_type = procedure;

    fetchDentiraAddOnsProducts(
      {
        page: addOnsProductsPage,
        size: addOnsProductsSize,
        searchTxt: addOnProductsSearchTxt,
      },
      body
    );
  }, [addOnsProductsPage, addOnsProductsSize]);

  useEffect(() => {
    if (Array.isArray(mappingsPropData) && mappingsPropData.length > 0) {
      const updated = mappingsPropData.map((mapping, index) => ({
        ...mapping,
        dentira_products: (mapping.dentira_products || []).map((product) =>
          product.hasOwnProperty("add_on")
            ? product
            : { ...product, primary: true }
        ),
        isExpanded: index === 0,
        id: `${Date.now()}_${index}`,
      }));
      setMappings(updated);
      setOldMappings(updated);
      setSelectedMappingId(updated[0]?.id);
    }
  }, [mappingsPropData]);

  useEffect(() => {
    setProcedure("");
    setSubProcedure("");
    setMaterial("");

    setProcedureOptions([]);
    setSubProcedureOptions([]);
    setMaterialOptions([]);

    fetchInitialFilters();

    setPrimaryProductsPage(pageNo);
    setAddOnsProductsPage(pageNo);

    setPrimaryProductsSearchTxt("");
    setAddOnProductsSearchTxt("");

    setPrimaryProductsSize(size);
    setAddOnsProductsSize(size);

    fetchDentiraPrimaryProducts(
      {
        page: primaryProductsPage,
        size: primaryProductsSize,
        searchTxt: primaryProductsSearchTxt,
      },
      {}
    );

    fetchDentiraAddOnsProducts(
      {
        page: addOnsProductsPage,
        size: addOnsProductsSize,
        searchTxt: addOnProductsSearchTxt,
      },
      {}
    );
  }, [selectedMappingId]);

  const fetchInitialFilters = async () => {
    const { fetchDentiraProductFilters } = props;
    const filters = await fetchDentiraProductFilters();
    setProcedureOptions(
      filters.map((filter) => ({
        value: filter?.procedure_type,
        label: filter?.display_name || filter?.procedure_type,
        description: filter?.description || "",
        count: filter?.product_count,
      }))
    );
  };

  const fetchProcedureFilters = async (filters) => {
    const { fetchDentiraProductFilters } = props;
    const result = await fetchDentiraProductFilters(filters);
    setSubProcedureOptions(
      result.map((filter) => ({
        value: filter?.sub_procedure,
        label: filter?.display_name || filter?.sub_procedure,
        description: filter?.description || "",
        count: filter?.product_count,
      }))
    );
  };

  const fetchSubProcedureFilters = async (filters) => {
    const { fetchDentiraProductFilters } = props;
    const result = await fetchDentiraProductFilters({
      procedure,
      subProcedure,
      material,
    });
    setMaterialOptions(
      result.map((filter) => ({
        value: filter?.material,
        label: filter?.display_name || filter?.material,
        description: filter?.description || "",
        count: filter?.product_count,
      }))
    );
  };

  const fetchMaterialFilters = async () => {
    const { fetchDentiraProductFilters } = props;
    const filters = await fetchDentiraProductFilters({
      procedure,
      subProcedure,
      material,
    });
  };

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  const toggleCollapseHandler = (id) => {
    setMappings((prev) =>
      prev.map((mapping, i) => {
        if (mapping?.id === id && !mapping?.isExpanded) {
          setSelectedMappingId(mapping?.id);
          return { ...mapping, isExpanded: true };
        } else if (mapping?.id === id && mapping?.isExpanded) {
          setSelectedMappingId(mapping?.id);
          return { ...mapping, isExpanded: true };
        } else return { ...mapping, isExpanded: false };
      })
    );
  };

  const mappingDuplicateHandler = (id) => {
    let mappingId = `${Date.now()}_${mappings?.length}`;
    setMappings((prevMappings) => {
      const updatedPrevMapping = prevMappings.map((prevMapping) => {
        return {
          ...prevMapping,
          isExpanded: false,
        };
      });
      const newMapping = {
        ...(prevMappings.find((mapping) => mapping?.id === id) || {}),
        dentira_products: [],
        id: mappingId,
        isExpanded: true,
      };
      return [...updatedPrevMapping, newMapping];
    });
    setSelectedMappingId(mappingId);
  };
  const removeMappings = (
    productType = "",
    itemId = "",
    id = "",
    isPrimary
  ) => {
    setMappings((prevMappings) =>
      prevMappings.map((mapping) => {
        if (mapping.id !== id) return mapping;

        let updated = mapping[productType]?.filter((p) => p.item_id !== itemId);

        if (
          productType === "dentira_products" &&
          isPrimary &&
          mapping.lab_products?.length === 1
        ) {
          const addOns = updated.filter((p) => p?.add_on);
          if (addOns.length > 1) updated = [addOns[0]];
        }

        return { ...mapping, [productType]: updated };
      })
    );
  };

  const addLabProductMapping = (id, data) => {
    setMappings((prevMappings) =>
      prevMappings.map((mapping) => {
        if (mapping.id === id) {
          const exists = mapping.lab_products.some(
            (prod) => prod.item_id === data.value
          );
          if (!exists) {
            return {
              ...mapping,
              lab_products: [
                ...mapping.lab_products,
                { item_id: data.value, name: data.label },
              ],
            };
          }
        }
        return mapping;
      })
    );
  };

  const addDentiraPrimaryProductMapping = (product) => {
    setMappings((prevMappings) =>
      prevMappings.map((mapping) => {
        if (mapping.id === selectedMappingId) {
          // Remove any existing primary: true product
          const updatedProducts = mapping.dentira_products.filter(
            (p) => !p.primary
          );
          return {
            ...mapping,
            dentira_products: [
              ...updatedProducts,
              { item_id: product.item_id, name: product.name, primary: true },
            ],
          };
        }
        return mapping;
      })
    );
  };

  const addAddOnsProductMapping = (addOnsProduct) => {
    setMappings((prevMappings) =>
      prevMappings.map((mapping) => {
        if (mapping.id === selectedMappingId) {
          const exists = mapping.dentira_products.some(
            (p) => p?.add_on && p.item_id === addOnsProduct.item_id
          );

          if (exists) {
            return {
              ...mapping,
              dentira_products: mapping.dentira_products.filter(
                (p) => p.item_id !== addOnsProduct.item_id
              ),
            };
          } else {
            if (disablePrimaryTabHandler() || hasOneLabProductAndOneAddOn()) {
              return {
                ...mapping,
                dentira_products: [
                  ...mapping.dentira_products.filter((p) => !p.add_on),
                  {
                    item_id: addOnsProduct.item_id,
                    name: addOnsProduct.name,
                    add_on: true,
                  },
                ],
              };
            } else {
              return {
                ...mapping,
                dentira_products: [
                  ...mapping.dentira_products,
                  {
                    item_id: addOnsProduct.item_id,
                    name: addOnsProduct.name,
                    add_on: true,
                  },
                ],
              };
            }
          }
        }

        return mapping;
      })
    );
  };

  const isPrimaryProductChecked = (product = {}) => {
    const selectedMapping =
      mappings?.find((mapping) => mapping?.id === selectedMappingId) || {};

    const selectDentiraPrimaryProduct =
      selectedMapping?.dentira_products?.find((product) => product?.primary) ||
      {};
    return product?.item_id === selectDentiraPrimaryProduct?.item_id;
  };

  const isAddOnProductChecked = (addOnProduct = {}) => {
    const selectedMapping =
      mappings?.find((mapping) => mapping?.id === selectedMappingId) || {};

    if (
      selectedMapping?.dentira_products?.some(
        (product) =>
          product?.add_on && product?.item_id === addOnProduct?.item_id
      )
    ) {
      return true;
    }
    return false;
  };

  const disablePrimaryTabHandler = () => {
    const selectedMapping =
      mappings?.find((mapping) => mapping?.id === selectedMappingId) || {};

    const hasDentiraPrimaryProduct = selectedMapping?.dentira_products?.some(
      (product) => product?.primary
    );

    const hasAddOnsProduct = selectedMapping?.dentira_products?.some(
      (product) => product?.add_on
    );
    const hasLabProductMoreThanTwo = selectedMapping?.lab_products?.length >= 2;
    const isDisabled =
      !hasDentiraPrimaryProduct && hasAddOnsProduct && hasLabProductMoreThanTwo;

    if (isDisabled && selectedTab === 0) {
      setSelectedTab(1);
    }

    return isDisabled;
  };

  const hasOneLabProductAndOneAddOn = () => {
    const selectedMapping =
      mappings?.find((mapping) => mapping?.id === selectedMappingId) || {};

    const dentiraProducts = selectedMapping?.dentira_products || [];
    const labProducts = selectedMapping?.lab_products || [];

    const hasDentiraPrimaryProduct = dentiraProducts.some(
      (product) => product?.primary
    );

    const addOnsProductCount = dentiraProducts.filter(
      (product) => product?.add_on
    ).length;

    const hasOneAddOnsProduct = addOnsProductCount === 1;
    const hasOneLabProduct = labProducts.length === 1;

    return !hasDentiraPrimaryProduct && hasOneAddOnsProduct && hasOneLabProduct;
  };

  const disableAddOnsTabHandler = () => {
    const selectedMapping =
      mappings?.find((mapping) => mapping?.id === selectedMappingId) || {};
    const hasDentiraPrimaryProduct = selectedMapping?.dentira_products?.some(
      (product) => product?.primary
    );
    const hasLabProductMoreThanTwo = selectedMapping?.lab_products?.length >= 2;
    const isDisabled = hasDentiraPrimaryProduct && hasLabProductMoreThanTwo;

    if (isDisabled && selectedTab === 1) {
      setSelectedTab(0);
    }
    return isDisabled;
  };

  const isMappingModified = (mappingId) => {
    const mapping = mappings?.find((m) => m?.id === mappingId);
    const oldMapping = oldMappings?.find((m) => m?.id === mappingId);

    if (!mapping || !oldMapping) return true;

    const getIdSet = (arr) => new Set(arr?.map((item) => item.item_id));

    const labCurrent = getIdSet(mapping.lab_products || []);
    const labOld = getIdSet(oldMapping.lab_products || []);
    const dentiraCurrent = getIdSet(mapping.dentira_products || []);
    const dentiraOld = getIdSet(oldMapping.dentira_products || []);

    const hasLabDiff =
      [...labCurrent].some((id) => !labOld.has(id)) ||
      [...labOld].some((id) => !labCurrent.has(id));

    const hasDentiraDiff =
      [...dentiraCurrent].some((id) => !dentiraOld.has(id)) ||
      [...dentiraOld].some((id) => !dentiraCurrent.has(id));

    return hasLabDiff || hasDentiraDiff;
  };

  const oldMappingHasMappingId = (mappingId, checkDentiraProducts = false) => {
    if (checkDentiraProducts) {
      const oldMapping = oldMappings?.find(
        (mapping) => mapping?.id === mappingId
      );
      return oldMapping && oldMapping?.dentira_products?.length;
    }
    return oldMappings.some((mapping) => mapping?.id === mappingId);
  };

  const cleanDentiraProducts = (products) =>
    products.map(({ primary, ...rest }) =>
      primary === true ? { ...rest, add_on: false } : { ...rest }
    );

  const handleClose = (closePopup = false) => {
    if (onSubmit) onSubmit();
    setDialogBoxAction(dialogBoxInitAction);
    if (onClose && closePopup) onClose();
  };

  const createMapping = async (mappingId) => {
    const { addDentiraMapping, updateSuccessMessage } = props;
    const mapping = mappings?.find((m) => m?.id === mappingId);
    if (!mapping) return;

    const cleanedDentiraProducts = cleanDentiraProducts(
      mapping.dentira_products
    );

    await addDentiraMapping({
      lab_products: mapping.lab_products,
      dentira_products: cleanedDentiraProducts,
    });

    // Update both mappings and oldMappings
    setMappings((prev) => prev.map((m) => (m.id === mappingId ? mapping : m)));

    setOldMappings((prev) => [...prev, mapping]);

    updateSuccessMessage(true, `Mapping created successfully.`);
    handleClose();
  };

  const createMappingHandler = (mappingId) => {
    setDialogBoxAction({
      open: true,
      title: "Create Mapping",
      content: "Are you sure you want to create this Mapping?",
      onTrue: (_) => {
        createMapping(mappingId);
      },
      onFalse: () => {
        setDialogBoxAction(dialogBoxInitAction);
      },
      onTrueText: "Create",
      onFalseText: "Cancel",
      errorButton: false,
    });
  };

  const updateMapping = async (mappingId) => {
    const { updateDentiraMapping, updateSuccessMessage } = props;

    const mapping = mappings?.find((m) => m?.id === mappingId);
    const oldMapping = oldMappings.find((m) => m?.id === mappingId);
    if (!mapping || !oldMapping) return;

    await updateDentiraMapping(
      {
        lab_products: oldMapping.lab_products,
        dentira_products: cleanDentiraProducts(oldMapping.dentira_products),
      },
      {
        lab_products: mapping.lab_products,
        dentira_products: cleanDentiraProducts(mapping.dentira_products),
      }
    );

    // Update both mappings and oldMappings
    setMappings((prev) => prev.map((m) => (m.id === mappingId ? mapping : m)));

    setOldMappings((prev) =>
      prev.map((m) => (m.id === mappingId ? mapping : m))
    );

    updateSuccessMessage(true, `Mapping updated successfully.`);
    handleClose();
  };

  const updateMappingHandler = (mappingId) => {
    setDialogBoxAction({
      open: true,
      title: "Update Mapping",
      content: "Are you sure you want to update this Mapping?",
      onTrue: (_) => {
        updateMapping(mappingId);
      },
      onFalse: () => {
        setDialogBoxAction(dialogBoxInitAction);
      },
      onTrueText: "Update",
      onFalseText: "Cancel",
      errorButton: false,
    });
  };

  const deleteMapping = async (mappingId) => {
    const { removeDentiraMapping, updateSuccessMessage } = props;
    const prefix = mappingId.split("_")[0];

    if (!oldMappingHasMappingId(mappingId)) {
      // Only in mappings → frontend-only
      const updatedMappings = mappings
        .filter((m) => m?.id !== mappingId)
        .map((m, index) => ({
          ...m,
          isExpanded: index === 0,
          id: `${prefix}_${index}`,
        }));

      setMappings(updatedMappings);

      setSelectedMappingId(`${prefix}_${0}`);

      const closePopup = !updatedMappings?.length;

      handleClose(closePopup);
      updateSuccessMessage(true, `Mapping deleted successfully.`);
      return;
    }

    // Present in oldMappings → need to call backend
    const mapping = mappings?.find((m) => m?.id === mappingId);
    if (!mapping) return;

    await removeDentiraMapping({
      lab_products: mapping.lab_products.map(({ item_id, name }) => ({
        item_id,
        name,
      })),
      dentira_products: mapping.dentira_products.map(({ item_id, name }) => ({
        item_id,
        name,
      })),
    });

    // Update both mappings and oldMappings

    const updatedMappings = mappings
      .filter((m) => m?.id !== mappingId)
      .map((m, index) => ({
        ...m,
        isExpanded: index === 0,
        id: `${prefix}_${index}`,
      }));

    setMappings(updatedMappings);

    setOldMappings((prev) =>
      prev
        .filter((m) => m?.id !== mappingId)
        .map((m, index) => ({
          ...m,
          isExpanded: index === 0,
          id: `${prefix}_${index}`,
        }))
    );

    setSelectedMappingId(`${prefix}_${0}`);

    updateSuccessMessage(true, `Mapping deleted successfully.`);
    const closePopup = !updatedMappings?.length;

    handleClose(closePopup);
  };

  const deleteMappingHandler = (mappingId) => {
    setDialogBoxAction({
      open: true,
      title: "Delete Mapping?",
      content: "Are you sure you want to delete this Mapping?",
      onTrue: (_) => {
        deleteMapping(mappingId);
      },
      onFalse: () => {
        setDialogBoxAction(dialogBoxInitAction);
      },
      onTrueText: "Delete",
      onFalseText: "Cancel",
      errorButton: true,
    });
  };

  const resetMappingHandler = (mappingId) => {
    setMappings((prevMappings) =>
      prevMappings.map((mapping) => {
        if (mapping.id === mappingId) {
          const oldMapping = oldMappings.find((m) => m.id === mappingId);

          if (oldMapping) {
            return {
              ...mapping,
              lab_products: oldMapping.lab_products,
              dentira_products: oldMapping.dentira_products,
            };
          }

          // if no old mapping found, clear dentira_products
          return {
            ...mapping,
            dentira_products: [],
          };
        }

        return mapping;
      })
    );
  };

  const canShowDeleteMappingBtn = (mappingId) => {
    // if no mapping for the supplier product then dont show delete mapping btn

    return !(
      oldMappings?.[0]?.id === mappingId &&
      oldMappings.length === 1 &&
      !oldMappings?.[0]?.dentira_products?.length
    );
  };

  const isMappingAlreadyExists = (mappingId) => {
    const mapping = mappings?.find((m) => m?.id === mappingId);

    const extractItemIds = (products) =>
      products
        ?.map((p) => p.item_id)
        .sort()
        .join(",");

    return oldMappings.some((oldMapping) => {
      const labProductsEqual =
        extractItemIds(mapping.lab_products) ===
        extractItemIds(oldMapping.lab_products);

      const dentiraProductsEqual =
        extractItemIds(mapping.dentira_products) ===
        extractItemIds(oldMapping.dentira_products);

      return (
        oldMapping?.id !== mappingId && labProductsEqual && dentiraProductsEqual
      );
    });
  };

  const onCloseHandler = () => {
    const mappingIds = mappings?.map((mapping) => mapping?.id) || [];
    const oldMappingIds =
      oldMappings?.map((oldMapping) => oldMapping?.id) || [];

    // Find mapping IDs not present in oldMappings
    const unsavedMappingIds = mappingIds.filter(
      (id) => !oldMappingIds.includes(id)
    );

    const mappingNumbers = unsavedMappingIds.map(
      (id) => parseInt(id?.split("_")[1]) + 1
    );
    const hasUnSavedChanges = mappingNumbers.length > 0;

    if (hasUnSavedChanges) {
      setDialogBoxAction({
        open: true,
        title: "Discard Mapping?",
        content: `You have ${mappingNumbers.length} unsaved changes to the current mapping . If you continue, you will lose all the changes. Do you want to continue?`,
        onTrue: (_) => {
          onClose();
        },
        onFalse: () => {
          setDialogBoxAction(dialogBoxInitAction);
        },
        onTrueText: "Discard",
        onFalseText: "Cancel",
        errorButton: true,
      });
    } else {
      onClose();
    }
  };

  return (
    <Dialog fullScreen anchor="top" open={open} onClose={onCloseHandler}>
      <DrawerHeader
        justifyContent="space-between"
        sx={{ borderBottom: 1, borderColor: "divider", p: 2 }}
        style={{ minHeight: "unset" }}
      >
        <TitleTypography padding={"0.5rem 1.5rem"}>
          Add / Edit Mapping
        </TitleTypography>
        <IconButton onClick={onCloseHandler}>
          <Close />
        </IconButton>
      </DrawerHeader>

      <Grid container>
        <MappingContainer item xs={4} padding={"0 !important"}>
          <MappingPaper>
            {mappings.map((mapping, index) => (
              <MappingCard
                key={mapping?.id}
                mapping={mapping}
                index={index}
                isExpanded={mapping.isExpanded}
                toggleCollapseHandler={toggleCollapseHandler}
                mappingDuplicateHandler={mappingDuplicateHandler}
                removeMappings={removeMappings}
                addLabProductMapping={addLabProductMapping}
                resetMappingHandler={resetMappingHandler}
                isMappingModified={isMappingModified}
                isMappingAlreadyExists={isMappingAlreadyExists}
                oldMappingHasMappingId={oldMappingHasMappingId}
                updateMappingHandler={updateMappingHandler}
                createMappingHandler={createMappingHandler}
                deleteMappingHandler={deleteMappingHandler}
                canShowDeleteMappingBtn={canShowDeleteMappingBtn}
              />
            ))}
          </MappingPaper>
        </MappingContainer>
        <MappingContainer item xs={8}>
          {/* <TitleTypography gutterBottom>
            Mapping 
            {parseInt(selectedMappingId?.split("_")?.[1] || 0) + 1}
          </TitleTypography> */}
          <TitleTypography gutterBottom>
            Browse Dentira Products To Map
          </TitleTypography>
          <MappingRuleNote>
            Note: You can select either one primary product with add-ons or a
            group of compatible add-ons.
          </MappingRuleNote>
          <SelectDentiraProductFilters
            procedureOptions={procedureOptions}
            subProcedureOptions={subProcedureOptions}
            materialOptions={materialOptions}
            procedure={procedure}
            subProcedure={subProcedure}
            material={material}
            setProcedure={setProcedure}
            setSubProcedure={setSubProcedure}
            setMaterial={setMaterial}
          />
          <Box sx={{ mb: 2 }} style={{ display: "flex" }}>
            <StyledTabs value={selectedTab} onChange={handleTabChange}>
              <StyledTab
                label={
                  <TabLabelBox>
                    <TabLabelText>Primary Products</TabLabelText>
                    <TabCountText>{primaryProducts?.totalResults}</TabCountText>
                  </TabLabelBox>
                }
                disabled={disablePrimaryTabHandler()}
              />
              <StyledTab
                label={
                  <TabLabelBox>
                    <TabLabelText>Add Ons</TabLabelText>
                    <TabCountText>{addOnsProducts?.totalResults}</TabCountText>
                  </TabLabelBox>
                }
                disabled={disableAddOnsTabHandler()}
              />
            </StyledTabs>
            <SearchField
              fullWidth
              size="small"
              placeholder={
                selectedTab === 0
                  ? "Search Primary Products"
                  : "Search Add Ons Product"
              }
              value={
                selectedTab === 0
                  ? primaryProductsSearchTxt
                  : addOnProductsSearchTxt
              }
              onChange={(e) => {
                if (selectedTab === 0) {
                  setPrimaryProductsSearchTxt(e.target.value);
                } else {
                  setAddOnProductsSearchTxt(e.target.value);
                }
              }}
            />
          </Box>
          {selectedTab === 0 && (
            <>
              {!primaryProducts?.totalResults ? (
                <NoOption>
                  {/* <ImgContainers src={HillSvg} /> */}
                  <NoOptionsTypography>
                    {" "}
                    {"No results found"}
                  </NoOptionsTypography>
                </NoOption>
              ) : (
                <ProductListBox>
                  <Grid container spacing={2} sx={{ mb: 2 }}>
                    <Grid item xs={6}>
                      <HeaderLabelTypography>
                        PRODUCT NAME
                      </HeaderLabelTypography>
                    </Grid>
                    <Grid item xs={6}>
                      <HeaderLabelTypography>PRODUCT ID</HeaderLabelTypography>
                    </Grid>
                  </Grid>
                  {primaryProducts?.products?.map((primaryProduct, index) => (
                    <AddOnItemGrid
                      onClick={() =>
                        addDentiraPrimaryProductMapping(primaryProduct)
                      }
                      container
                      spacing={2}
                      key={index}
                    >
                      <AddOnNameContainer item xs={6}>
                        <Radio
                          checked={isPrimaryProductChecked(primaryProduct)}
                          size="small"
                        />
                        <Box sx={{ display: "flex", flexDirection: "column" }}>
                          <ProductNameTypography>
                            {primaryProduct?.name}
                          </ProductNameTypography>
                          {primaryProduct?.description && (
                              <SubtitleTypography
                              title={primaryProduct?.description}
                              sx={{
                                color: "#757575",
                                fontSize: "12px",
                                overflow: "hidden",
                                display: "-webkit-box",
                                WebkitBoxOrient: "vertical",
                                WebkitLineClamp: 2,
                                maxWidth: "100%",
                              }}
                            >
                              {primaryProduct?.description}
                            </SubtitleTypography>
                          )}
                        </Box>
                      </AddOnNameContainer>
                      <Grid item xs={6}>
                        <ProductNameTypography>
                          {primaryProduct?.item_id}
                        </ProductNameTypography>
                      </Grid>
                    </AddOnItemGrid>
                  ))}
                  <TablePagination
                    component="div"
                    count={primaryProducts?.totalResults}
                    page={primaryProductsPage - 1}
                    onPageChange={(e, page) => {
                      setPrimaryProductsPage(parseInt(page, size) + 1);
                    }}
                    rowsPerPage={primaryProductsSize}
                    onRowsPerPageChange={(e) => {
                      setPrimaryProductsPage(pageNo);
                      setPrimaryProductsSize(parseInt(e.target.value, size));
                    }}
                  />
                </ProductListBox>
              )}
            </>
          )}
          {selectedTab === 1 && (
            <>
              {!addOnsProducts?.totalResults ? (
                <NoOption>
                  {/* <ImgContainers src={HillSvg} /> */}
                  <NoOptionsTypography>
                    {" "}
                    {"No results found"}
                  </NoOptionsTypography>
                </NoOption>
              ) : (
                <AddOnsContainer>
                  <Grid container spacing={2} sx={{ mb: 2 }}>
                    <Grid item xs={6}>
                      <HeaderLabelTypography>
                        PRODUCT NAME
                      </HeaderLabelTypography>
                    </Grid>
                    <Grid item xs={6}>
                      <HeaderLabelTypography>PRODUCT ID</HeaderLabelTypography>
                    </Grid>
                  </Grid>
                  {addOnsProducts?.products?.map((addOnsProduct) => (
                    <Box sx={{ mb: 3 }} key={addOnsProduct.item_id}>
                      <AddOnItemGrid
                        container
                        spacing={2}
                        key={addOnsProduct.item_id}
                      >
                        <AddOnNameContainer item xs={6}>
                          <Checkbox
                            size="small"
                            sx={{
                              color: "#E0E0E0",
                              "&.Mui-checked": { color: "#00A67E" },
                            }}
                            checked={isAddOnProductChecked(addOnsProduct)}
                            onChange={() =>
                              addAddOnsProductMapping(addOnsProduct)
                            }
                          />

                          <Box
                            sx={{ display: "flex", flexDirection: "column" }}
                          >
                            <ProductNameTypography>
                              {addOnsProduct?.name}
                            </ProductNameTypography>
                            {addOnsProduct?.description && (
                                <SubtitleTypography
                                title={addOnsProduct?.description}
                                sx={{
                                  color: "#757575",
                                  fontSize: "12px",
                                  overflow: "hidden",
                                  display: "-webkit-box",
                                  WebkitBoxOrient: "vertical",
                                  WebkitLineClamp: 2,
                                  maxWidth: "100%",
                                }}
                              >
                                {addOnsProduct?.description}
                              </SubtitleTypography>
                            )}
                          </Box>
                        </AddOnNameContainer>
                        <Grid item xs={6}>
                          <ProductNameTypography>
                            {addOnsProduct?.item_id}
                          </ProductNameTypography>
                        </Grid>
                      </AddOnItemGrid>
                    </Box>
                  ))}
                  <TablePagination
                    component="div"
                    count={addOnsProducts?.totalResults}
                    page={addOnsProductsPage - 1}
                    onPageChange={(e, page) => {
                      setAddOnsProductsPage(parseInt(page, size) + 1);
                    }}
                    rowsPerPage={addOnsProductsSize}
                    onRowsPerPageChange={(e) => {
                      setAddOnsProductsPage(1);
                      setAddOnsProductsSize(parseInt(e.target.value, size));
                    }}
                  />
                </AddOnsContainer>
              )}
            </>
          )}
        </MappingContainer>
      </Grid>
      <DialogBox
        open={dialogBoxAction?.open}
        title={dialogBoxAction?.title}
        content={dialogBoxAction?.content}
        onTrue={dialogBoxAction?.onTrue}
        onFalse={dialogBoxAction?.onFalse}
        onTrueText={dialogBoxAction?.onTrueText || ""}
        cancelText={dialogBoxAction?.onFalseText || ""}
        errorButton={dialogBoxAction?.errorButton || false}
      />
    </Dialog>
  );
};

const mapStateToProps = (state) => {
  return {};
};

const mapDispatch = {
  fetchDentiraProductFilters,
  fetchAutocompleteDentiraPrimaryProducts,
  fetchAutocompleteDentiraAddOnsProducts,
  addDentiraMapping,
  updateSuccessMessage,
  updateDentiraMapping,
  removeDentiraMapping,
};

export default withRouter(connect(mapStateToProps, mapDispatch)(MappingFormV2));
